import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(
    new Date(iso),
  );
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
}

/** Valor em centavos (menor unidade da moeda) formatado em pt-BR. */
export function formatMoney(cents: number | null | undefined, currency: string): string {
  if (cents === null || cents === undefined) return "—";
  try {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}

/** "há 5 min", "há 2 h", "há 3 dias" ou a data, para o "última sincronização há X". */
export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "nunca";
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.round(diff / 60_000);
  if (min < 1) return "agora mesmo";
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  if (d < 30) return `há ${d} ${d === 1 ? "dia" : "dias"}`;
  return formatDate(iso);
}

/** Cor do selo de verificação de um Business Manager. */
export function verificationVariant(
  status: string | null,
): "success" | "warning" | "secondary" | "destructive" {
  switch (status) {
    case "verified":
      return "success";
    case "pending":
    case "pending_need_more_info":
    case "pending_submission":
      return "warning";
    case "rejected":
    case "revoked":
    case "failed":
    case "expired":
      return "destructive";
    default:
      return "secondary";
  }
}
